import Actions                 from 'Redux/Actions';
import { OrganizerRepository } from 'Domain/Repositories';
import { ofType }              from 'redux-observable';
import { from, EMPTY }         from 'rxjs';
import { mergeMap }            from 'rxjs/operators';
import { TEpic }               from 'Redux/Config';

export const findOrganizerEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findOrganizerRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        OrganizerRepository.findById(id)
          .then((organizer) => Actions.findOrganizerSuccess({ organizer }))
          .catch(error => Actions.findOrganizerFailure({ error })),
      );
    }),
  );
};
